<template>
  <div><Table/></div>
</template>

<script>
import Table from '@/view/content/Table.vue'

export default {
components:{
  Table
}

}
</script>

<style>

</style>